export default {
  name: 'XButtonGroup'
};